import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const modalDescription = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
    margin: `${-space.s16}px ${space.s70}px ${space.s24}px 0`,
  },
]);

export const actionsContainer = style([
  {
    display: 'flex',
    gap: space.s8,
    marginTop: space.s48,
  },
]);

globalStyle(`${actionsContainer} > button`, {
  flex: `1 1 0`,
});

export const targetTag = style([
  {
    background: themeVars.container.secondary.background.idle,
    borderRadius: borderRadius.r64,
    paddingLeft: space.s12,
    paddingRight: space.s4,
    height: 32,
  },
]);

export const targetsBottomTip = style([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.s8,
  },
]);
